import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('ruleDefinitions', { startValue: undefined });
